var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"subtitle-2 my-5"},[_vm._v(_vm._s(_vm.title))]),_c('Map',{attrs:{"url":_vm.map_url}}),_c('CountByState',{staticClass:"my-3",attrs:{"result":_vm.result}}),_c('CountByCity',{staticClass:"my-3",attrs:{"result":_vm.result}}),_c('CountByCate',{staticClass:"my-3",attrs:{"url":_vm.cate_url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }